<template>
  <div class='SDAU_style eq_box'>
    <div class='treeBox'>
      <div class='left_tree'>
        <div class='treeHeader'>
          按所在位置
        </div>
        <el-tree :data="areaData" @node-click="areatreeClick" node-key="id" ref="areatree" highlight-current>
        </el-tree>
      </div>
      <div class='left_tree'>
        <div class='treeHeader'>
          按设备分类
        </div>
        <el-tree :data="typeData" @node-click="typetreeClick" node-key="id" ref="typetree" highlight-current
          :props="defaultProps">
        </el-tree>
      </div>
    </div>
    <div class='eqMsgbox'>
      <div class='eq_header'>
        <div style='font-size: 24px;font-family: Source Han Sans SC;font-weight: bold;color: #333333;'>
          仪器设备</div>
        <span style="font-size:14px;color:#999999;">
          您的位置：
          <span style='color:#999999;cursor: pointer;' @click="toHome">首页></span>
          <span style="color:#188335">仪器设备</span>
        </span>
      </div>
      <div class='sdau_search'>
        <el-form ref="form" :model="formData" label-width="100px" :inline="true">
          <el-row>
            <el-col :span='8'>
              <el-form-item label="设备编号">
                <el-input placeholder="请输入设备编号" v-model="formData.equipmentNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="formData.equipmentName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span='8'>
              <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索
              </el-button>
              <el-button icon="el-icon-refresh" size="mini" @click="e_reset">重置 </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class='eq_cardbox'>
        <el-empty v-if='eqmentData.length == 0' description="暂无数据"></el-empty>
        <div v-for='(item, index) in eqmentData' :key='index + String(item.id)' class='eq_card'>
          <div id="cardtops" class='cardtop'>
            <img id="imghw" v-if='item.thumbnailPath' style='width: 75%;' :src="baseurl + '/' + item.thumbnailPath">
            <img id="imghw" v-if='!item.thumbnailPath' style='width: 75%;' src="../../assets/images/img_blank.png">
            <div style='padding-left:16px;width: 100%;margin-top: 10px;'>
              <div style='font-size: 18px;font-family: PingFang SC;font-weight: bold;color: #333333;padding-bottom: 5px;'>
                {{ item.equipmentName }}</div>
              <span style='font-size: 14px;font-family: Source Han Sans SC;font-weight: 400;color: #333333;'>规格型号：
                {{ item.equipmentModel }}</span>
            </div>
          </div>
          <div style='height:50px'>
            <el-button style='height:101%;width: 50%;border-radius: 0px;font-size:18px' type="primary"
              v-Login='() => toDetail(item)'>
              预约申请
            </el-button>
            <el-button style='height:101%;width: 50%;margin:0;border-radius: 0px;border-top:none;font-size:18px'
              @click='moreMsg(item)'>
              更多信息
            </el-button>
          </div>
        </div>
        <pagination style="width: 100%;" v-show="total > 0" :pageSizes="pageSizes" :total="total"
          :page.sync="formData.pageNum" :limit.sync="formData.pageSize" @pagination='init' />
      </div>
    </div>
  </div>
</template>
<script>
const { APIURl } = require('@/utils/apiUrl')
export default {
  data() {
    return {
      formData: {
        pageNum: 1,
        pageSize: 10,
        equipmentAreaId: '',
        equipmentAreaTreeId: '',
        treeId: ''
      },
      pageSizes: [5, 10, 20, 50, 100, 300],
      eqmentData: [],
      areaData: [],
      typeData: [],
      total: 0,
      defaultProps: {
        label: 'nodeName',
        children: 'childList'
      },
      baseurl: '',
      arealevel: ''
    }
  },
  methods: {
    formatTree(tree) {
      const result = [];
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        const obj = node
        this.$set(obj, 'label', node.nodeName)
        this.$set(obj, 'children', [])
        if (node.areaList) {
          // 遍历第二层子节点
          node.areaList.forEach(child1 => {
            const childObj = child1
            this.$set(childObj, 'label', child1.areaName)
            obj.children.push(childObj);
          });
        }
        result.push(obj);
      }
      return result;
    },
    toDetail(item) {
      this.$net(`/v1/billing/scheme/querySchemeByEquipmentId/${item.id}`, 'get').then(res => {
        this.$router.push({
          path: '/appointment',
          query: {
            id: item.id,
            billingMethod: res.data.billingMethod
          }
        })
      }).catch(err => {

      })
    },
    toHome() {
      this.$router.push({ path: '/' })
    },
    moreMsg(item) {
      this.$router.push({
        path: '/eqmentappointmentmsg',
        query: {
          id: item.id
        }
      })
    },
    handleQuery() {
      this.formData.pageNum = 1
      this.init()
    },
    e_reset() {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        equipmentAreaId: this.formData.equipmentAreaId,
        treeId: this.formData.treeId
      }
      this.init()
    },
    areatreeClick(data, node) {
      if (node.level == 2) {
        this.formData.equipmentAreaTreeId = ''
        if (this.formData.equipmentAreaId == '') {
          this.formData.equipmentAreaId = this.$refs.areatree.getCurrentKey()
        }
        else {
          if (this.formData.equipmentAreaId == this.$refs.areatree.getCurrentKey()) {
            this.$refs.areatree.setCurrentKey(null);
            this.formData.equipmentAreaId = ''
          }
          else {
            this.formData.equipmentAreaId = this.$refs.areatree.getCurrentKey()
          }
        }
      }
      else {
        this.formData.equipmentAreaId = ''
        if (this.formData.equipmentAreaTreeId == '') {
          this.formData.equipmentAreaTreeId = this.$refs.areatree.getCurrentKey()
        }
        else {
          if (this.formData.equipmentAreaTreeId == this.$refs.areatree.getCurrentKey()) {
            this.$refs.areatree.setCurrentKey(null);
            this.formData.equipmentAreaTreeId = ''
          }
          else {
            this.formData.equipmentAreaTreeId = this.$refs.areatree.getCurrentKey()
          }
        }
      }

      this.init()
      // }

    },
    typetreeClick(data, node) {
      if (this.formData.treeId == '') {
        this.formData.treeId = this.$refs.typetree.getCurrentKey()
      }
      else {
        if (this.formData.treeId == this.$refs.typetree.getCurrentKey()) {
          this.$refs.typetree.setCurrentKey(null);
          this.formData.treeId = ''
        }
        else {
          this.formData.treeId = this.$refs.typetree.getCurrentKey()
        }
      }
      this.init()
    },
    init() {
      this.$net('/v1/userClient/home/selectHomeEquipmentList', 'get', this.formData).then(res => {
        this.$set(this, 'eqmentData', res.data.list)
        this.total = res.data.total
      })
    },

    getTree() {
      this.baseurl = APIURl
      this.$net('/v1/userClient/home/selectAreaTree', 'get').then(res => {
        this.areaData = this.formatTree(res.data)
      })
      this.$net('/v1/userClient/home/selectEquipmentTree', 'get').then(res => {
        this.typeData = res.data
      })
    },
    resetHeight() {
      if (this.$route.path != '/eqment') {
        window.removeEventListener('resize', this.resetimgHeight, false);
        return
      }
      var div_ls = document.getElementsByTagName('div')
      for (var i = 0; i < div_ls.length; i++) {
        if (div_ls[i].getAttribute('id') == 'cardtops') {
          div_ls[i].style.height = (div_ls[i].offsetWidth + 10) + 'px'
        }
      }

      var img_ls = document.getElementsByTagName('img')
      for (var i = 0; i < img_ls.length; i++) {
        if (img_ls[i].getAttribute('id') == 'imghw') {
          img_ls[i].style.height = img_ls[i].offsetWidth + 'px'
        }
      }
    },
  },
  created() {
    this.init()
    this.getTree()
  },
  mounted() {
    window.addEventListener('resize', this.resetHeight);
  },
  updated() {
    this.resetHeight();
  },
}
</script>
<style lang="scss" scoped>
::v-deep.eq_box {
  .el-tree-node__label {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #333333;
  }

  margin-top: 32px;
  display: flex;
  justify-content: space-between;

  .treeBox {
    width: 20%;

    .left_tree {
      border: 1px solid #d7dce0;
      opacity: 1;
      margin-bottom: 32px;

      .treeHeader {
        background: #f6f6f6;
        height: 64px;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: bold;
        color: #333333;
        padding-left: 32px;
        line-height: 64px;
      }
    }
  }

  .eqMsgbox {
    width: 75%;

    .eq_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .eq_cardbox {
      width: auto;
      display: flex;
      flex-wrap: wrap;

      .eq_card {
        display: flex;
        flex-direction: column;
        margin-right: 3.5%;
        width: 31%;
        height: auto;
        margin-bottom: 60px;

        .cardtop {
          background: #ffffff;
          border: 1px #d7dce0 solid;
          padding-top: 10px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }

    .eq_cardbox .eq_card:nth-child(3n) {
      margin-right: 0px;
    }
  }
}
</style>